import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import markerImg from '../static/marker.svg';

interface IPosition {
  lat: number;
  lng: number;
}

interface IGoogleMaps {
  googleMapsApiKey: string;
  center: IPosition;
  marker: IPosition;
}

const containerStyle = {
  height: '220px',
};

function GoogleMaps({ googleMapsApiKey, center, marker }: IGoogleMaps) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey,
  });

  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
      <Marker icon={markerImg} position={marker} />
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(GoogleMaps);
